import type { EntityConfigDefinition } from '../../types/entityConfig'

const config: EntityConfigDefinition = {
  name: 'DATA_ELEMENT',
  idField: 'DATA_ELEMENT_ID',
  
  // Form processing configuration
  keepAuditFieldsOnUpdate: false,
  
  // Environment copy configuration
  preserveOnCopy: ['DATA_ELEMENT_ID'],
  
  // Fields to remove before GraphQL mutations
  fieldsToRemove: [],
  
  // Environment comparison configuration
  comparisonConfig: {
    matchingFields: ['ELEMENT_KEY'],
    comparisonFields: ['ELEMENT_KEY', 'ELEMENT_VALUE'],
    displayFields: ['DATA_ELEMENT_ID', 'ELEMENT_KEY', 'ELEMENT_VALUE', 'CREATED_BY_USER_ID', 'CREATED_DATE', 'CHANGED_BY_USER_ID', 'CHANGED_DATE']
  },
  
  // Fields configuration
  fields: [
    "DATA_ELEMENT_ID",
    "ELEMENT_KEY",
    "ELEMENT_VALUE",
    "CREATED_BY_USER_ID",
    "CREATED_DATE",
    "CHANGED_BY_USER_ID",
    "CHANGED_DATE"
  ],
  
  // Form fields configuration
  formFields: [
    {
      "name": "ELEMENT_KEY",
      "type": "text",
      "required": true,
      "disabled": false
    },
    {
      "name": "ELEMENT_VALUE",
      "type": "text",
      "required": true,
      "disabled": false
    },
    {
      "name": "CREATED_BY_USER_ID",
      "type": "number",
      "required": false,
      "disabled": false
    },
    {
      "name": "CREATED_DATE",
      "type": "text",
      "required": false,
      "disabled": true
    },
    {
      "name": "CHANGED_BY_USER_ID",
      "type": "number",
      "required": false,
      "disabled": false
    },
    {
      "name": "CHANGED_DATE",
      "type": "text",
      "required": false,
      "disabled": true
    }
  ]
}

export default config

